import { ContactsLastImportId } from 'modules/contacts/contacts-import/types/contacts-import-interface'

export const getInvalidContactsLastImportRows = (contactsLastImportId: ContactsLastImportId) =>
  `/api/dashboard/customer/contact/contacts/import/${contactsLastImportId}/download-invalid-data`
